import React from "react";
import PropTypes from "prop-types";

import * as S from "./styled";

const Loading = props => (
  <S.Loading size={props.size} {...props}>
    <S.LoadingIcon size={props.size} {...props} />
  </S.Loading>
);

Loading.defaultProps = {
  size: "default"
};

Loading.propTypes = {
  size: PropTypes.oneOf(["default", "small"])
};

/**
 * @deprecated please use "@streeteasy/design-system/loader" instead
 */
export default Loading;
